module.exports = {
  NEON: 'NEON',
  SICOOB: 'SICOOB',
  TOPAZIO: 'TOPAZIO',
  CELCOIN: 'CELCOIN',
  STONE: 'STONE',
  ABC_BRASIL: 'ABC_BRASIL',
  BTG: 'BTG'
};
